import { getAnalytics } from "firebase/analytics";
import { initializeApp } from "firebase/app";
import { GoogleAuthProvider, getAuth } from "firebase/auth";

// Your web app's Firebase configuration
const firebaseConfig = {
	apiKey: "AIzaSyAlwoe2sOWuirvyJWBfU5OIbLrHBvV_M1Y",
	authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
	projectId: "xwallet-6c57c",
	storageBucket: "xwallet-6c57c.firebasestorage.app",
	messagingSenderId: "803464786986",
	appId: "1:803464786986:web:96bf74a0aafc63f88ebf53",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Authentication and get a reference to the service
export const auth = getAuth(app);

// Initialize Google Auth Provider
export const googleProvider = new GoogleAuthProvider();

// Initialize Analytics (optional)
export const analytics = typeof window !== "undefined" ? getAnalytics(app) : null;

export default app;
